import React from "react";
import { useNavigate } from "react-router-dom";
import { deleteVariation } from "../../../backend-services";
import { useSubUserStore } from "../../../state/useSubUserStore";
import { Button } from "../../common";
import { showToast } from "../../../utils/toastUtils";


interface DisablePromptProps {
  setShowPrompt: (show: boolean) => void;
  userId: string;
}

const DisablePrompt = ({ userId, setShowPrompt }: DisablePromptProps) => {
  const [isDisabling, setIsDisabling] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");

  const { disableUser, users } = useSubUserStore((state) => ({
    disableUser: state.disableUser,
    users: state.users,
  }));

  const user = users.find((u) => u.id === userId);

  const handleDisable = async () => {
    setIsDisabling(true);
    try {
      const newStatus = user?.status === "ENABLED" ? "DISABLED" : "ENABLED";
      await disableUser(userId, { status: newStatus });
      showToast('User disabled successfully!', 'success');
      setShowPrompt(false);
    } catch (error: any) {
      showToast(`${error.message}`, 'error');
    } finally {
      setIsDisabling(true);
    }
  };

  return (
    <div className="disable-prompt">
      <div className="">
        <div className="flex justify-start mt-[13px] ">
          <h1 className="text-[#475467] text-[13px] md:text-[18px] lg:text-[18px]">
            Are you sure you want to disable this user?
          </h1>
        </div>
        <div
          role="form"
          className="flex lg:mt-[0.3em] mt-[-1em] md:mt-0 justify-end items-end "
          onSubmit={(e) => e.preventDefault()}
        >
          <div className="mt-[32px]  lg:w-[215px] w-[130px] lg:text-[16px] text-[12px] md:text-[14px] flex justify-end items-end mr-[1em] lg:mr-[-3em] rounded-lg ">
            <Button
              text={"Cancel"}
              size="small"
              onClick={() => setShowPrompt(false)}
              variant="white"
            />
          </div>
          <div className="mt-[32px] lg:w-[215px] w-[130px] flex justify-end items-end rounded-lg lg:text-[16px] text-[12px] md:text-[14px]">
            <Button
              isLoading={isDisabling}
              text={"Yes, Disable"}
              size="small"
              onClick={handleDisable}
              variant="secondary"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export { DisablePrompt };
